import React, { Component } from "react";
import AboutRemoteWork_BannerTitle from "../layouts/about/carees/AboutRemoteWork_BannerTitle";
import AboutRemoteWork_SideBar from "../layouts/about/carees/AboutRemoteWork_SideBar";
import AboutRemoteWork_SiteContent from "../layouts/about/carees/AboutRemoteWork_SiteContent";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
class AboutRemoteWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "O nama",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/about-us",
          titlelink: "O nama",
          border: "|",
          name: "Rad na daljinu",
          heading: "Rad na daljinu",
        },
      ],
    };
  }
  render() {
    return (
      <div className="header-fixed page sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <AboutRemoteWork_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />
                <AboutRemoteWork_SiteContent />
                <AboutRemoteWork_SideBar />
              </div>
            </div>
          </div>
          <Footer />
          {this.state.headers.map((data, idx) => (
            <BottomBar data={data} key={idx} />
          ))}
        </div>
      </div>
    );
  }
}

export default AboutRemoteWork;
